export default __webpack_public_path__ + "static/media/dansketext-semibolditalic.c0c1b749.eot";